import { isInitialized } from '@cbridge-utils/network';
import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { supersetStoreSelector } from '../../superset.selector';

export const chartListSubscriberPropsSelector = createCachedSelector(
  [
    path(supersetStoreSelector).chartList.networkStatus(),
  ],
  (networkStatus) => {
    return {
      shouldBeLoaded: !isInitialized(networkStatus),
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
